var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 1024c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512c0 281.6-230.4 512-512 512zM512 64c-249.6 0-448 198.4-448 448s198.4 448 448 448c249.6 0 448-198.4 448-448s-198.4-448-448-448z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M652.8 729.6c-6.4 0-12.8 0-12.8-6.4l-121.6-64-121.6 64c-12.8 6.4-25.6 6.4-32 0-12.8-6.4-12.8-19.2-12.8-32l25.6-134.4-108.8-96c-12.8-12.8-12.8-25.6-12.8-32 6.4-12.8 12.8-19.2 25.6-19.2l140.8-25.6 64-128c12.8-19.2 44.8-19.2 57.6 0l64 128 140.8 19.2c12.8 0 19.2 12.8 25.6 19.2-6.4 12.8-6.4 25.6-19.2 38.4l-102.4 96 25.6 134.4c0 12.8 0 25.6-12.8 32 0 6.4-6.4 6.4-12.8 6.4zM512 595.2c6.4 0 12.8 0 12.8 6.4l83.2 38.4-12.8-89.6c0-12.8 0-19.2 6.4-25.6l64-64-89.6-12.8c-12.8 0-19.2-6.4-25.6-19.2l-38.4-83.2-38.4 83.2c-6.4 6.4-12.8 12.8-25.6 19.2l-89.6 12.8 64 64c6.4 6.4 12.8 19.2 6.4 25.6l-12.8 89.6 83.2-44.8c0 0 6.4 0 12.8 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.92a956fa616d0a2c28ec791ca47110b4.svg";
export { ForwardRef as ReactComponent };